import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  I2cBrand,
  I2cIcon,
  I2cButton,
  I2cInput,
  I2cSwitch,
} from "@webcomponents/i2cwebcomponents/dist/react";
import AsideSection from "../../../Components/AsideSection/AsideSection";
// @ts-expect-error
import logo from "../../../assets/images/i2c_logo.svg";
// @ts-expect-error
import banner from "../../../assets/images/login_art.svg";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import ConfirmaionModal from "../../../Components/ConfirmationModal/ConfirmationModal";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthHeadDesc from "../../../Components/SharedComponent/AuthHeaderSection/AuthHeaderSection";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { validationSchema } from "./ValidationSchema";
import { useMutation } from "react-query";
import AuthService from "../../../Services/AuthServices";
import "./Login.scss";
import "../../../Utils/shared-styles/Authentication.scss";
import AlertMessage from "../../../Components/SharedComponent/Alert/Alert";
import { UserStateContext } from "../../../Context/AuthContext";
import DarkModeBtn from "../../../Components/DarkModeBtn/DarkModeBtn";
import microSoftIcon from "../../../../src/assets/images/microsoft-icon.svg";

const LoginPage = () => {
  const form = useRef();
  const userEmail = useRef();
  const AuthContext = UserStateContext();
  const [recaptcha, setRecaptcha] = useState("");
  const [reValidateRecaptcha, setReValidateRecaptcha] = useState(false);
  const [showConfirmatonModal, setShowConfirmatonModal] = useState(false);
  const navigate = useNavigate();
  const [searchParam, setSearchParam] = useSearchParams();
  const isSetPasswordSuccess = searchParam.get("set-password");
  const [statusUrl, setStatusUrl] = useState(false);
  const [codeUrl, setCodeUrl] = useState({
    code: false,
    state: false,
    sessionState: false,
  });
  const [popUp, setPopUp] = useState(false);
  const [azureError, setAzureError] = useState(true);

  const onVerify = useCallback((token) => {
    setReValidateRecaptcha(false);
    setRecaptcha(token);
  }, []);

  const loginWithAzure = useMutation({
    mutationFn: async (values) => {
      return await AuthService.getAzureData();
    },
    onSuccess: (response) => {
      if (response.data.status) {
        setStatusUrl(response.data);
      }
    },
    onError: (error) => {
      setReValidateRecaptcha(true);
    },
  });

  useEffect(() => {
    loginWithAzure.mutate();
  }, []);

  // const handleStatusWindow = () => {
  //   setAzureError(true);
  //   if (statusUrl.url) {
  //     const windowWidth = 500;
  //     const windowHeight = 600;
  //     const left = (window.screen.width - windowWidth) / 2;
  //     const top = (window.screen.height - windowHeight) / 2;
  //     const windowFeatures = `width=${windowWidth},height=${windowHeight},left=${left},top=${top},resizable=yes`;
  //     const popUpWindow = window.open(statusUrl.url, 'PopupWindow', windowFeatures);
  //     if (popUpWindow) {
  //       setPopUp(popUpWindow);
  //       popUpWindow.addEventListener('load', () => {
  //         var vars = [], hash;
  //         var hashes = popUpWindow.location.href.slice(popUpWindow.location.href.indexOf('?') + 1).split('&');
  //         for (var i = 0; i < hashes.length; i++) {
  //           hash = hashes[i].split('=');
  //           vars.push(hash[0]);
  //           vars[hash[0]] = hash[1];
  //         }
  //         setCodeUrl(prevState => ({
  //           ...prevState,
  //           code: vars.code,
  //           state: vars.state,
  //           sessionState: vars.session_state,
  //         }));
  //       });
  //     }
  //   }
  // };

  const handleStatusWindow = () => {
    setAzureError(true);
    if (statusUrl.url) {
      const windowWidth = 500;
      const windowHeight = 600;
      const left = (window.screen.width - windowWidth) / 2;
      const top = (window.screen.height - windowHeight) / 2;
      const windowFeatures = `width=${windowWidth},height=${windowHeight},left=${left},top=${top},resizable=yes`;
      const popUpWindow = window.open(
        statusUrl.url,
        "PopupWindow",
        windowFeatures,
      );

      if (popUpWindow) {
        setPopUp(popUpWindow);

        const interval = setInterval(() => {
          try {
            if (popUpWindow.location.href.includes("?")) {
              const vars = [];
              const hashes = popUpWindow.location.href
                .slice(popUpWindow.location.href.indexOf("?") + 1)
                .split("&");
              const params = {};
              for (let i = 0; i < hashes.length; i++) {
                const hash = hashes[i].split("=");
                vars.push(hash[0]);
                params[hash[0]] = decodeURIComponent(hash[1]);
              }
              if (params.code && params.state && params.session_state) {
                setCodeUrl((prevState) => ({
                  ...prevState,
                  code: params.code,
                  state: params.state,
                  sessionState: params.session_state,
                }));
                clearInterval(interval);
              }
            }
          } catch (error) {
            if (popUpWindow.closed) {
              clearInterval(interval);
            }
            console.error("Error accessing popup window URL", error);
          }
        }, 500);
      }
    }
  };

  useEffect(() => {
    if (codeUrl.code && codeUrl.state && codeUrl.sessionState) {
      sendCodeUrlRequest.mutate(codeUrl);
    }
  }, [codeUrl]);

  useEffect(() => {
    let interval;
    if (popUp) {
      interval = setInterval(() => {
        if (popUp.closed) {
          clearInterval(interval);
          setPopUp(null);
          onPopupClosed();
        }
      }, 500);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [popUp]);

  const onPopupClosed = () => {
    setPopUp(false);
  };

  const sendCodeUrlRequest = useMutation({
    mutationFn: async (values) => {
      return await AuthService.postAzureData(values);
    },
    onSuccess: (data) => {
      AuthContext.setToken(data.data.token);
      AuthContext.setSessionCount(data.data.sessionCount);
      AuthContext.setUserRole(data.data.userRole);
      if (data?.data?.temporaryPwd || data?.data?.passwordExpired) {
        AuthContext.setIsTempPwd(true);
        navigate("/set-password");
      } else {
        if (data.data.sessionCount > 0) {
          navigate("/concurrent-sessions");
        } else {
          if (data.data.userRole === 5) {
            navigate("/impl");
          } else {
            navigate("/sales");
          }
        }
      }
      if (popUp) {
        popUp.close();
      }
    },
    onError: (error) => {
      setReValidateRecaptcha(true);
      setAzureError(error.response.status);
      if (popUp) {
        popUp.close();
      }
    },
  });

  // Login mutation
  const login = useMutation({
    mutationFn: async (values) => {
      return await AuthService.login({ ...values, recaptcha: recaptcha });
    },
    onSuccess: (data) => {
      AuthContext.setToken(data.data.token);
      AuthContext.setSessionCount(data.data.sessionCount);
      AuthContext.setUserRole(data.data.userRole);

      if (data?.data?.temporaryPwd || data?.data?.passwordExpired) {
        AuthContext.setIsTempPwd(true);
        navigate("/set-password");
      } else {
        if (data.data.sessionCount > 0) {
          navigate("/concurrent-sessions");
        } else {
          if (data.data.userRole === 5) {
            navigate("/impl");
          } else {
            navigate("/sales");
          }
        }
      }
    },
    onError: () => {
      setReValidateRecaptcha(true);
    },
  });

  // FormEventHandler<HTMLFormElement>
  const handleLogin = (e) => {
    if (recaptcha) {
      login.mutate(e);
    } else {
    }
  };

  // Hook form initialization and methods
  const methods = useForm({
    resolver: zodResolver(validationSchema),
    mode: "onChange",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      email: "",
      password: "",
    },
  });

  // Hook form methods destructuring
  const {
    handleSubmit,
    formState: { errors, isValid },
  } = methods;
  const handleButtonClick = () => {
    navigate(".", { replace: true });
  };
  return (
    <React.Fragment>
      <div className="layout_aside">
        <div className="layout_aside-left">
          <AsideSection
            image={banner}
            heading={
              <span>
                Commitment to delivering <br /> exceptional solutions
              </span>
            }
            description={`customer-centric approach and dedication to driving success through seamless implementations`}
          />
        </div>
        <div className="layout_aside-right forStandAlone">
          <div className="right-container">
            <div className="login  auth__main-right">
              <div className="dark-mode-btn-wrapper">
                <DarkModeBtn />
              </div>
              <div className="auth__right-content">
                <div className="login__content-wrapper auth__content-wrapper">
                  <header id="header">
                    <I2cBrand
                      className="login__logo"
                      label="Client Implementation Portfolio"
                      logo={logo}
                      slot="brand"
                      style={{
                        "--brand-logo-img-width": "2.5rem",
                        "--brand-logo-img-height": "auto",
                      }}
                      // accessKeyLabel='login_logo_label'
                      target=""
                    />
                  </header>
                  <AuthHeadDesc
                    classNameHeader="login-page-header"
                    title="Sign in to Your Account"
                    description="Please enter your User ID and Password to sign in."
                  />
                  <div className="login__form">
                    {/* <ToastMessage variant='danger' /> */}
                    {/* error alert message */}
                    {!azureError && (
                      <div className="alert-message-section-login">
                        <AlertMessage
                          open={true}
                          message={"Credentials are Invalid."}
                        />
                      </div>
                    )}
                    {login.isError && (
                      <div className="alert-message-section-login">
                        <AlertMessage
                          open={login.isError}
                          message={
                            login?.error?.response?.message ??
                            "Login Failed."
                          }
                        />
                      </div>
                    )}
                    <div onClick={handleButtonClick}>
                      <AlertMessage
                        variant="success"
                        message={"Password updated successfully"}
                        headerArt="linear-tick-circle"
                        open={isSetPasswordSuccess}
                        closeAble={true}
                      />
                    </div>
                    <form
                      onSubmit={handleSubmit(handleLogin)}
                      ref={form}
                      autoComplete="on"
                    >
                      <div className="login__form-group login__userID-group">
                        <Controller
                          name="email"
                          control={methods.control}
                          render={({ field }) => (
                            <I2cInput
                              size="large"
                              label="User Email"
                              placeholder="user@i2cinc.com"
                              name="email"
                              type="email"
                              required
                              className={`auth__custom-input fw-400`}
                              autofocus
                              invalid={
                                errors.email | login.isError ? true : false
                              }
                              ref={userEmail}
                              onI2cInput={field.onChange}
                              onI2cBlur={field.onBlur}
                            >
                              {login.isError && (
                                <I2cIcon
                                  slot="suffix"
                                  color="red"
                                  name="cs-linear-alert-circle"
                                ></I2cIcon>
                              )}
                            </I2cInput>
                          )}
                        />
                        {/* <ErrorMessage
                          show={errors.email ? true : false}
                          message={errors.email?.message ?? "Invalid input"}
                        /> */}
                      </div>
                      <div className="login__form-group login__password-group">
                        <Controller
                          name="password"
                          control={methods.control}
                          render={({ field }) => (
                            <>
                              <I2cInput
                                size="large"
                                type="password"
                                label="Password"
                                placeholder="Enter Password"
                                name="password"
                                required
                                invalid={
                                  errors.password | login.isError ? true : false
                                }
                                className="login__custom-input fw-400"
                                onI2cInput={field.onChange}
                                onI2cBlur={field.onBlur}
                                togglePassword={true /* passIcon */}
                              >
                                <I2cIcon
                                  slot="hide-password-icon"
                                  name={"linear-eye"}
                                />
                                <I2cIcon
                                  slot="show-password-icon"
                                  name={"linear-eye-slash"}
                                />
                              </I2cInput>
                            </>
                          )}
                        />
                        {/* <ErrorMessage
                          show={errors.password ? true : false}
                          message={errors.password?.message ?? "Invalid input"}
                        /> */}
                        <div className="login__forget-password">
                          <I2cButton variant="link gray" size="x-small">
                            <Link
                              to={"/forgot-password"}
                              style={{
                                textDecoration: "none",
                                fontWeight: 400,
                              }}
                            >
                              Forgot Password?
                            </Link>
                          </I2cButton>
                        </div>
                      </div>
                      <GoogleReCaptcha
                        onVerify={onVerify}
                        refreshReCaptcha={reValidateRecaptcha}
                      />
                      <div className="login__remember-password">
                        <div className="login__remember">
                          <I2cSwitch
                            className="switch__label"
                            name=""
                            onI2cChange={() => null}
                          >
                            Remember me
                          </I2cSwitch>
                          <I2cButton
                            loading={login.isLoading}
                            disabled={login.isLoading || !isValid}
                            type="submit"
                            className="login__sign-btn"
                            size={"medium"}
                          >
                            Sign In
                          </I2cButton>

                          <I2cButton
                            onclick={handleStatusWindow}
                            type="button"
                            className="signin-with-microsoft-btn"
                            size={"medium"}
                            variant="secondary gray"
                            disabled={popUp}
                          >
                            <span className="signin-microsoft-span">
                              <img src={microSoftIcon} />
                              Sign in with Microsoft
                            </span>
                          </I2cButton>
                          <ConfirmaionModal
                            open={showConfirmatonModal}
                            setOpen={() => setShowConfirmatonModal(false)}
                            title={"Problem Signing In?"}
                            headerArt={"cs-linear-alert-circle"}
                            message={
                              <span className="problem-logging-in-modal-content">
                                Please send your requests/inquiries to{" "}
                                <a
                                  className="problem-logging-in-modal-email-link"
                                  href="mailto:csd@i2cinc.com"
                                >
                                  csd@i2cinc.com
                                </a>
                              </span>
                            }
                            variant="neutral"
                            layout={"layoutCenter"}
                            cancelButtonText={"Close"}
                            closeButtonSize="large"
                          >
                            <I2cButton
                              loading={false}
                              type="button"
                              onClick={() => setShowConfirmatonModal(true)}
                              variant="secondary gray"
                              size={"medium"}
                              className="login__sign-btn login__forgot-btn"
                            >
                              Problem Signing In?
                            </I2cButton>
                          </ConfirmaionModal>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer className="login__footer_mobile">
            <p className="login-aside__footer-text">
              i2c Inc. &copy; {new Date().getFullYear()} All Rights Reserved.
            </p>
          </footer>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LoginPage;
